import { PickerMapping } from 'types/pickerMap'

type Props = {
  field: PickerMapping
}

const PickerMapViewRow = ({ field }: Props) => {
  return (
    <div className="grid grid-cols-2 items-center gap-4 border-t p-4 text-sm">
      <div>{field.pickerName}</div>
      <div>{field.empId}</div>
    </div>
  )
}

export default PickerMapViewRow
